import { render } from "./Special.vue?vue&type=template&id=5d5539c8"
import script from "./Special.vue?vue&type=script&lang=js"
export * from "./Special.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__